import { DesignElementType } from '../../../types/baseQualityItem';

export const testCaseSearchDesignElementsMap: Record<string, string> = {
  testCase1: DesignElementType.REQ1,
  testCase2: DesignElementType.REQ2,
  testCase3: DesignElementType.REQ3,
};
